import { useHistory } from 'react-router-dom';
import i18next from 'i18next';
import React, { useEffect, useState } from 'react';

import mosAuth, { isMosLoginConfigured } from '@services/mosAuth';

/**
 * Public OIDC callback. Completes PKCE token exchange, then redirects to /auth/mapal-os/complete.
 */
const MosCallback = () => {
  const history = useHistory();
  const [error, setError] = useState(null);
  const [errorDetail, setErrorDetail] = useState(null);

  useEffect(() => {
    const complete = async () => {
      if (!isMosLoginConfigured()) {
        setError(i18next.t('GENERAL.CONNECTION_MOS_FAILURE'));
        setErrorDetail('MOS OIDC is not configured (missing issuer/clientId).');

        return;
      }

      try {
        await mosAuth.completeMosCallback();
      } catch (err) {
        // Surface the real OIDC error — "Unable to login" alone hides root cause (userinfo, state, etc.).
        console.error('[MosCallback] completeMosCallback failed', err);
        setError(i18next.t('GENERAL.CONNECTION_MOS_FAILURE'));
        setErrorDetail(err?.message || String(err));
      }
    };

    complete();
  }, []);

  if (error) {
    return (
      <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
        <p>{error}</p>
        {errorDetail && (
          <pre style={{ whiteSpace: 'pre-wrap', color: '#b00020', maxWidth: 640 }}>
            {errorDetail}
          </pre>
        )}
        <button type="button" onClick={() => history.replace('/login')}>
          {i18next.t('GENERAL.CONNECTION')}
        </button>
      </div>
    );
  }

  return null;
};

export default MosCallback;
